import React from "react";
import ReactSelectCreatable from "react-select/creatable";

export default function CreatableSelect({
  options,
  onChange,
  onInputChange,
  inputValue,
  className = "",
  ...props
}) {
  function handleKeyDown(event) {
    if (!inputValue) {
      return;
    }

    if (event.key === "Enter" || event.key === "Tab") {
      onChange({ label: inputValue, value: inputValue });
      onInputChange("");
      event.preventDefault();
    }
  }

  const styles = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected || state.isFocused ? "#6C0CAE" : "#FFF",
      color: state.isSelected || state.isFocused ? "#FFF" : "#333",
    }),

    multiValue: (provided) => ({
      ...provided,
      borderRadius: 100,
      backgroundColor: "#6C0CAE",
      color: "#FFF",
    }),

    multiValueLabel: (provided) => ({
      ...provided,
      color: "#FFF",
      fontSize: 12,
    }),

    multiValueRemove: (provided, state) => ({
      ...provided,
      borderTopRightRadius: 100,
      borderBottomRightRadius: 100,
      backgroundColor:
        state.isFocused || state.isSelected ? "#6C0CAE" : "#6C0CAE",
    }),
  };

  return (
    <>
      <ReactSelectCreatable
        components={{ DropdownIndicator: null }}
        isClearable
        isMulti
        menuIsOpen={false}
        onChange={(newValue) =>
          newValue === null ? onChange([]) : onChange(newValue)
        }
        onKeyDown={handleKeyDown}
        onInputChange={(newValue) => onInputChange(newValue)}
        inputValue={inputValue}
        value={options}
        className={`form-select ${className}`}
        classNamePrefix="form-select"
        styles={styles}
        {...props}
      />
    </>
  );
}
